import React, { createContext, useContext, useState, useEffect } from 'react';

// Creamos el contexto
const TimeZoneContext = createContext();

// Este proveedor es donde definimos el valor del contexto
export const TimeZoneProvider = ({ children }) => {
  // Estado para almacenar la zona horaria del dispositivo
  const [timeZone, setTimeZone] = useState(''); // Inicialmente vacío

  useEffect(() => {
    // Obtener la zona horaria del dispositivo
    const deviceTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimeZone(deviceTimeZone); // Establecer la zona horaria del dispositivo
  }, []);

  return (
    <TimeZoneContext.Provider value={{ timeZone }}>
      {children}
    </TimeZoneContext.Provider>
  );
};

// Este es el custom hook para acceder al contexto de la zona horaria
export const useTimeZone = () => {
  return useContext(TimeZoneContext);
};
